import { render } from "./homeComp.vue?vue&type=template&id=f1414130&scoped=true"
import script from "./homeComp.vue?vue&type=script&lang=js"
export * from "./homeComp.vue?vue&type=script&lang=js"

import "./homeComp.vue?vue&type=style&index=0&id=f1414130&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1414130"]])

export default __exports__